import React from "react";
import { Text } from "react-native";
import moment from "moment";
import appStyles from "../../../appStyles";

export default function IntegrationDateTime({
  source = {},
  showDate = false,
  dateSeparator = " | ",
  hasSourceInfo = false,
}) {
  const { startTime, endTime } = source;
  const start = startTime ? moment(startTime).format("h:mm A") : "";
  const end = endTime ? moment(endTime).format("h:mm A") : "";
  const startDate = showDate
    ? startTime
      ? moment(startTime).format("MM/DD")
      : ""
    : null;

  return (
    <>
      {hasSourceInfo ? <Text style={appStyles.captionThin}> • </Text> : null}

      {startDate ? (
        <Text style={appStyles.captionThin}>{startDate}{dateSeparator}</Text>
      ) : null}

      {start && end ? (
        <Text style={appStyles.captionThin}>
          {start} - {end}
        </Text>
      ) : null}
    </>
  );
}
